import styled from "styled-components";

import { theme } from "@tm/utility/global";
import { deviceType } from "../../../static/utils";

type LandingFaqTitleProps = {
  marginBottom?: string;
  marginLeft?: string;
  customFaq?: string;
  margin?: string;
  $fontSize?: string;
  $fontWeight?: number;
  $lineHeight?: string;
  $marginBottom?: string;
  isCardView?: boolean;
};

export interface LandingFaqProps {
  customFaq?: string;
  margin?: string;
  isCommonLanding?: boolean;
  $padding?: string;
  $radius?: string;
  $shadow?: string;
  $width?: string;
  $gap?: string;
  $itemPadding?: string;
  $questionFontSize?: string;
  $questionFontWeight?: number;
  $questionLineHeight?: string;
  isCardView?: boolean;
}

export interface LandingFaqUiConfig {
  section?: Pick<LandingFaqProps, "$padding" | "$radius" | "$shadow">;
  title?: Pick<
    LandingFaqTitleProps,
    "$fontSize" | "$fontWeight" | "$lineHeight" | "$marginBottom"
  >;
  list?: Pick<LandingFaqProps, "$width" | "$gap">;
  item?: Pick<LandingFaqProps, "$itemPadding">;
  question?: Pick<
    LandingFaqProps,
    "$questionFontSize" | "$questionFontWeight" | "$questionLineHeight"
  >;
  isCardView?: boolean;
}

export const LandingFaqStyle = styled.section<LandingFaqProps>`
  ${(props) => props.margin && `margin: ${props.margin};`}
  display: flex;
  background: #fff;
  flex-direction: column;
  width: 100%;
  ${(props) =>
    props.isCardView &&
    `
    background: #f5f5f5;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    padding: 16px;
    border-radius: 0;
    box-sizing: border-box;
  `}
  ${(props) =>
    props.isCommonLanding &&
    !props.isCardView &&
    `
    width: 1200px;
    margin: 0 auto;
    padding: 24px;
    border-radius: 16px;
    background: #FFFFFF;
  `}
  ${(props) => props.$padding && `padding: ${props.$padding};`}
  ${(props) => props.$radius && `border-radius: ${props.$radius};`}
  ${(props) => props.$shadow && `box-shadow: ${props.$shadow};`}

  ${(props) => props.customFaq && ``}
`;

/** White rounded panel for FAQ accordion (MWeb card layout). */
export const LandingFaqCardShell = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 8px 0;
  width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
`;

export const LandingFaqTitle = styled.h3<LandingFaqTitleProps>`
  font-family: "Lato";
  font-weight: ${(props) => props.$fontWeight || 400};
  font-size: ${(props) => props.$fontSize || "48px"};
  line-height: ${(props) => props.$lineHeight || "56px"};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "0px")};
  margin-bottom: ${(props) =>
    props.$marginBottom || props.marginBottom || "56px"};
  color: ${theme.blackText};

  ${(props) =>
    props.isCardView &&
    `
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 12px;
    margin-left: 0;
  `}

  @media screen and ${deviceType.mobile} {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "0px")};

    ${(props) =>
      props.isCardView &&
      `
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 12px;
      margin-left: 0;
    `}
  }
`;

export const LandingFaqList = styled.ul<LandingFaqProps>`
  width: ${(props) =>
    props.$width || (props.isCommonLanding ? `1150px` : `1000px`)};

  li {
    margin-bottom: ${(props) => props.$gap || "16px"};
    position: relative;
    cursor: pointer;
  }

  li h5 {
    padding: ${(props) => props.$itemPadding || "24px"};

    @media screen and ${deviceType.mobile} {
      padding: 16px 35px 16px 16px;
    }
  }

  li p {
    padding: 0 24px 24px;
  }

  li:after {
    content: "";
    position: absolute;
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    right: 24px;
    top: 33px;
    transition: 0.3s ease-in;

    @media screen and ${deviceType.mobile} {
      top: 16px;
    }
  }

  li.close:after {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

  li.open:after {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  li:hover {
    background: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
  }

  li:last-child {
    margin-bottom: unset;
  }

  ${(props) =>
    props.customFaq &&
    `
            width:100%;
            gap:8px;
            margin-bottom: 24px;
            li {
                padding: 12px 16px;
                background: #FFFFFF;
                box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
                border-radius: 6px;
            }
            li h5 {
                padding: unset;
            }
            li p {
                padding:unset;
                font-size: 12px;
                line-height: 16px;
                color: #000000;
            }
            li:after {
                border: solid #008CFF;
                border-width: 0 2px 2px 0;
                padding: 4px;
                right: 24px;
                top: 13px;
            }
    `}

  @media screen and ${deviceType.mobile} {
    width: 100%;
  }

  ${(props) =>
    props.isCardView &&
    `
    width: 100% !important;
    max-width: none;
    gap: 0;
    margin-bottom: 0;

    li {
      margin-bottom: 0;
      background: transparent !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      border: none !important;
    }

    li:hover {
      background: transparent !important;
      box-shadow: none !important;
    }

    li h5 {
      padding: 14px 40px 14px 16px;
    }

    li p {
      padding: 0 16px 16px;
    }

    li:after {
      border-color: #9e9e9e;
      border-width: 0 2px 2px 0;
      padding: 3px;
      right: 16px;
      top: 50%;
      margin-top: -6px;
    }

    li.close:after {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }

    li.open:after {
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
    }
  `}
`;

export const LandingFaqQues = styled.h5<LandingFaqProps>`
  font-weight: ${(props) => props.$questionFontWeight || 700};
  font-size: ${(props) => props.$questionFontSize || "22px"};
  line-height: ${(props) => props.$questionLineHeight || "30px"};
  color: #000;
  ${(props) =>
    props.customFaq &&
    `
        font-size: 12px;
        line-height: 16px;
        color: #000000;`}

  @media screen and ${deviceType.mobile} {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
  }

  ${(props) =>
    props.isCardView &&
    `
    font-size: 15px;
    line-height: 20px;
    font-weight: 700;

    @media screen and ${deviceType.mobile} {
      font-size: 15px;
      line-height: 20px;
    }
  `}
`;

export const LandingFaqInfo = styled.div`
  display: flex;
  padding: 0px 24px 5px 0px;
  margin-bottom: 16px;
  align-items: center;

  img {
    height: 32px;
    width: 32px;
    margin-right: 10px;

    @media screen and ${deviceType.mobile} {
      height: 24px;
      width: 24px;
      margin-right: 8px;
    }
  }
  @media screen and ${deviceType.mobile} {
    margin-left: 16px;
  }
  font-family: lato, sans-serif;
  font-size: 12px;
  line-height: 14px;
  color: #757575;
`;

export const LandingFaqAns = styled.p`
  cursor: default;
  padding: 0px !important;
  a {
    color: #008cff;
  }
  li:after {
    border: 0px;
    border-width: 0px;
  }
`;
